import { createReducer, on } from "@ngrx/store";
import { RecordingsActions } from "./recordings.actions";
import { initialRecordingState, IRecording } from "./recordings.state";
import { initialInvestigatePopupState } from "../../common/models/recordings-popup.model";
import { createDefaultILoadableArray, onLoadableLoad, onLoadableSuccess } from "../../common/models";

export const recordingsReducer = createReducer(
    initialRecordingState,
    on(RecordingsActions.loadRecordings, state => ({
        ...onLoadableLoad(state),
        recordings: []
    })),
    on(RecordingsActions.loadRecordingsSuccess, (state, { recordings }) => ({
        ...onLoadableSuccess(state),
        recordings: [...recordings]
    })),
    on(RecordingsActions.setSelectedCameras, (state, { sensors }) => ({
        ...onLoadableSuccess(state),
        selectedCameras: [...sensors]
    })),
    on(RecordingsActions.setSelectedDateRange, (state, { dateRange }) => {
        const defaultStartDate = new Date();
        const defaultEndDate = new Date();

        defaultStartDate.setHours(0, 0, 0);
        defaultEndDate.setHours(23, 59, 59);

        const startDateTime = dateRange.start != null ? dateRange.start?.getTime() : defaultStartDate.getTime();
        const endDateTime = dateRange.end != null ? dateRange.end?.getTime() : defaultEndDate.getTime();
        const playbackDurationSecs = Math.round((endDateTime - startDateTime) / 1000);

        return {
            ...onLoadableSuccess(state),
            selectedDateRange: dateRange,
            durationInSecs: playbackDurationSecs
        }
    }),
    on(RecordingsActions.setMediaControls, (state, { enabled }) => ({
        ...state,
        mediaControls: enabled
    })),
    on(RecordingsActions.loadMediaMTXRecordings, state => ({
        ...state,
        cameraRecordings: { ...onLoadableLoad({ ...(createDefaultILoadableArray<IRecording>()) }) }
    })),
    on(RecordingsActions.loadMediaMTXRecordingsSuccess, (state, { recordings }) => ({
        ...state,
        cameraRecordings: {
            ...onLoadableSuccess({ ...state.cameraRecordings }),
            items: recordings
        }
    })),
    on(RecordingsActions.setSelectedCameras, (state, { sensors }) => ({
        ...onLoadableSuccess(state),
        selectedCameras: [...sensors]
    })),
    on(RecordingsActions.setMediaControlsSuccess, (state, { enabled }) => ({
        ...onLoadableSuccess(state),
        mediaControls: enabled,
    })),
    on(RecordingsActions.setShowUnscheduledCamsSuccess, (state, { enabled }) => ({
        ...onLoadableSuccess(state),
        showUnscheduledCams: enabled
    })),
    on(RecordingsActions.loadRecordingSettingsSuccess, (state, { mediaControls, unscheduledCams }) => ({
        ...onLoadableSuccess(state),
        mediaControls: mediaControls,
        showUnscheduledCams: unscheduledCams
    })),
    on(RecordingsActions.loadAlertBookmarks, state => ({
        ...state,
        bookmarksLoading: true,
    })),
    on(RecordingsActions.loadAlertBookmarksSuccess, (state, { bookmarks }) => ({
        ...state,
        bookmarksLoading: false,
        alertBookmarks: [...bookmarks],
    })),
    on(RecordingsActions.loadAlertBookmarksFailure, state => ({
        ...state,
        bookmarksLoading: false,
    })),
    on(RecordingsActions.toggleAlertBookmarks, (state, { enabled }) => ({
        ...state,
        bookmarksEnabled: enabled,
        bookmarksLoading: false,
        alertBookmarks: enabled ? state.alertBookmarks : [],
    })),
    on(RecordingsActions.clearAlertBookmarks, state => ({
        ...state,
        alertBookmarks: [],
        bookmarksLoading: false,
    })),
    on(RecordingsActions.openInvestigatePopupSuccess, (state, { filter }) => ({
        ...state,
        investigatePopup: { filter, popupWindowId: null, pendingOpen: true },
    })),
    on(RecordingsActions.openInvestigatePopupFailure, state => ({
        ...state,
        investigatePopup: initialInvestigatePopupState,
    })),
    on(RecordingsActions.investigatePopupFilterSent, (state, { popupWindowId, filter }) => ({
        ...state,
        investigatePopup: { filter, popupWindowId, pendingOpen: false },
    })),
    on(RecordingsActions.popupFilterReceived, (state, { filter }) => ({
        ...state,
        popupFilter: filter,
    })),
    on(RecordingsActions.popupFilterApplied, state => ({
        ...state,
        popupFilter: null,
    })),
    // The Investigate popup belongs to the window that opened it, not to the recordings
    // page, so leaving the recordings page must not forget it.
    on(RecordingsActions.clearState, state => ({
        ...initialRecordingState,
        investigatePopup: state.investigatePopup,
    })),
);
